<template>
  <b-container>
    <br/>
    <p>
      <b-alert variant="danger" show>Path not found: <b>{{ getPath }}</b></b-alert>
    </p>
    <b-button block variant="info" to="/">Home</b-button>
  </b-container>
</template>

<script>
  export default {
    name: 'NotFound',
    computed: {
      getPath() {
        if (this.$route.path.startsWith('/')) {
          return this.$route.path.substr(1);
        } else {
          return this.$route.path;
        }
      }
    }
  }
</script>
